<mat-card appearance="outlined">
    <mat-card-title class="btn btn-round btn-rose" style-="margin-left:5px;margin-right:5px;">Update User Detail</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
    <mat-card-content *ngIf="data != null">
        <form [formGroup]="editForm" (ngSubmit)="saveUser()">
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field color="accent">
                        <mat-label>Employee Id</mat-label>
                        <input matInput type="text" placeholder="EmployeeId" formControlName="employeeId">
                        <mat-error *ngIf="editForm.get('employeeId').hasError('required')">
                          Employee ID is required.
                        </mat-error>
                        <mat-error *ngIf="editForm.get('employeeId').hasError('maxlength')">
                           EmployeeId cannot be more than 20 characters.
                         </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field color="accent">
                        <mat-label>First Name</mat-label>
                        <input matInput type="text" placeholder="FirstName" formControlName="firstName">
                        <mat-error *ngIf="editForm.get('firstName').hasError('required')">
                          First Name is required.
                        </mat-error>
                         <mat-error *ngIf="editForm.get('firstName').hasError('maxlength')">
                           First name cannot be more than 20 characters.
                         </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field color="accent">
                        <mat-label>Last Name</mat-label>
                        <input matInput type="text" placeholder="LastName" formControlName="lastName">
                        <mat-error *ngIf="editForm.get('lastName').hasError('required')">
                          Last Name is required.
                        </mat-error>
                        <mat-error *ngIf="editForm.get('lastName').hasError('maxlength')">
                           EmployeeId cannot be more than 20 characters.
                         </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field color="accent">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" placeholder="Email" formControlName="email">
                        <mat-error *ngIf="editForm.get('email').hasError('required')">
                          Email is required.
                        </mat-error>
                        <mat-error *ngIf="editForm.get('email').hasError('invalidEmail')">
                              {{ editForm.get('email').getError('invalidEmail') }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field color="accent">
                        <mat-label>Mobile Number</mat-label>
                        <input matInput type="text" placeholder="Mobile" formControlName="phoneNumber">
                        <mat-error *ngIf="editForm.get('phoneNumber').hasError('required')">
                        Mobile Number is required.
                        </mat-error>
                        <mat-error *ngIf="editForm.get('phoneNumber').hasError('pattern')">
                        Mobile Number must be a 10-digit number.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field color="accent">  
                        <mat-label>Status</mat-label>              
                        <mat-select formControlName="appStatusId">
                            <mat-option [value]="null">Select an option</mat-option>
                            <mat-option *ngFor="let status of userStatus" [value]="status.appStatusId">
                              {{ status.status }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="editForm.get('appStatusId').hasError('required')">
                            Status is required.
                          </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field color="accent">   
                        <mat-label>Role Name</mat-label>                     
                        <mat-select formControlName="roleId">
                            <mat-option [value]="null">Select an option</mat-option>
                            <mat-option *ngFor="let role of roles" [value]="role.roleId">
                              {{ role.roleName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="editForm.get('roleId').hasError('required')">
                            Role is required.
                          </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field color="accent">
                        <mat-label>State</mat-label>       
                        <mat-select formControlName="stateId" (selectionChange)="getCitiesByStateId()">
                            <mat-option [value]="null">Select an option</mat-option>
                            <mat-option *ngFor="let state of states" [value]="state.stateId">
                              {{ state.stateName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="editForm.get('stateId').hasError('required')">
                            State is required.
                          </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4" *ngIf="cities.length > 0">                    
                    <mat-form-field color="accent">
                        <mat-label>City</mat-label>
                        <mat-select formControlName="cityId">
                            <mat-option [value]="null">Select an option</mat-option>
                            <mat-option *ngFor="let city of cities" [value]="city.cityId">
                              {{ city.cityName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="editForm.get('cityId').hasError('required')">
                            City is required.
                          </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row action-btn">
                <button md-raised-button type="button" class="btn btn-round btn-rose" (click)="close()">Close</button>
                 <button md-raised-button type="button" class="btn btn-round btn-rose"  (click)="saveUser()"  
                 [disabled]="!editForm.valid">Update</button>
            </div>
        </form>
    </mat-card-content>
</mat-card>

